var d={settlementId:["streetId","street","buildingId","building","postalCode","addressId"],streetId:["buildingId","building","postalCode","addressId"]};export{d as DOWNSTREAM_FIELDS};
//# sourceMappingURL=utils.js.map